"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_1 = require("@brandfree-front/lib");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const ParagraphEightContent_1 = require("./paragraphcontents/ParagraphEightContent");
const ParagraphElevenContent_1 = require("./paragraphcontents/ParagraphElevenContent");
const ParagraphFiveContent_1 = require("./paragraphcontents/ParagraphFiveContent");
const ParagraphFourContent_1 = require("./paragraphcontents/ParagraphFourContent");
const ParagraphNineContent_1 = require("./paragraphcontents/ParagraphNineContent");
const ParagraphOneContent_1 = require("./paragraphcontents/ParagraphOneContent");
const ParagraphSevenContent_1 = require("./paragraphcontents/ParagraphSevenContent");
const ParagraphSixContent_1 = require("./paragraphcontents/ParagraphSixContent");
const ParagraphTenContent_1 = require("./paragraphcontents/ParagraphTenContent");
const ParagraphThreeContent_1 = require("./paragraphcontents/ParagraphThreeContent");
const ParagraphTwelveContent_1 = __importDefault(require("./paragraphcontents/ParagraphTwelveContent"));
const ParagraphTwoContent_1 = require("./paragraphcontents/ParagraphTwoContent");
const StoresUtil_1 = require("../../util/StoresUtil");
let PublicPrivacyNotice = class PublicPrivacyNotice extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publicPrivacyNoticeStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "renderContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (react_1.default.createElement(lib_1.Grid, { gutter: "medium" },
                react_1.default.createElement(lib_1.GridColumn, { width: ['md-4'] },
                    react_1.default.createElement(lib_1.Affix, null,
                        react_1.default.createElement(lib_1.ArrowList, { outerBordered: true }, this.paragraphs.map((paragraph, index) => (react_1.default.createElement(lib_1.ArrowListItem, { url: "#", onClick: () => (0, lib_1.scrollToElement)(`theme-${index}`, 500, 100), key: index }, paragraph.heading)))))),
                react_1.default.createElement(lib_1.GridColumn, { width: ['md-8'] }, this.paragraphs.map((paragraph, index) => (react_1.default.createElement(react_1.Fragment, { key: index },
                    index !== 0 && react_1.default.createElement(lib_1.Separator, { spacing: paragraph.isSubParagraph ? 'small' : 'medium', color: "invisible" }),
                    react_1.default.createElement(lib_1.Text, null,
                        react_1.default.createElement(lib_1.Heading, { id: `theme-${index}`, level: paragraph.isSubParagraph ? 3 : 2, className: paragraph.isSubParagraph ? 'text-bold h4' : 'h3' }, paragraph.heading),
                        paragraph.content)))))))
        });
        Object.defineProperty(this, "renderMobileContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (react_1.default.createElement(lib_1.Accordion, null, this.paragraphs.map((paragraph, index) => (react_1.default.createElement(lib_1.AccordionItem, { id: `accordion-${index}`, key: index },
                react_1.default.createElement(lib_1.AccordionHeader, null,
                    react_1.default.createElement(lib_1.AccordionTitle, null, paragraph.heading)),
                react_1.default.createElement(lib_1.AccordionContent, null,
                    react_1.default.createElement(lib_1.Text, null, paragraph.content)))))))
        });
    }
    componentDidMount() {
        (0, mobx_1.runInAction)(() => {
            this.publicPrivacyNoticeStore.isPublicPrivacyNoticeOpen = true;
        });
    }
    componentWillUnmount() {
        (0, mobx_1.runInAction)(() => {
            this.publicPrivacyNoticeStore.isPublicPrivacyNoticeOpen = false;
        });
    }
    render() {
        const { isMobile } = this.props;
        const { translate } = this.translateStore;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(lib_1.Grid, null,
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-8'] },
                    react_1.default.createElement(lib_1.Text, null,
                        react_1.default.createElement(lib_1.Grid, null,
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'lg-8'] },
                                react_1.default.createElement(lib_1.Heading, { className: "h2 text-primary" }, translate('gdpr.privacy.notification.header.text.title')))),
                        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.header.text1')),
                        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.header.text2')),
                        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.header.text3')))),
                react_1.default.createElement(lib_1.GridColumn, { className: "hidden-xs hidden-sm", width: ['xs-12', 'md-4'] },
                    react_1.default.createElement(lib_1.Image, { sources: [
                            {
                                minWidth: '800px',
                                srcset: 'https://res.cloudinary.com/telia/image/upload/q_auto:best/w_560/v1627378261/iseteenindus/privaatsusteade_pebble2.png 560w, https://res.cloudinary.com/telia/image/upload/q_auto:best/w_1120/v1627378261/iseteenindus/privaatsusteade_pebble2.png 1120w'
                            }
                        ], srcset: "'\n          https://res.cloudinary.com/telia/image/upload/q_auto:best/w_240/v1627378261/iseteenindus/privaatsusteade_pebble2.png 240w,\n          https://res.cloudinary.com/telia/image/upload/q_auto:best/w_480/v1627378261/iseteenindus/privaatsusteade_pebble2.png 480w,\n          https://res.cloudinary.com/telia/image/upload/q_auto:best/w_720/v1627378261/iseteenindus/privaatsusteade_pebble2.png 720w", width: 680, role: "presentation" }))),
            react_1.default.createElement(lib_1.Separator, { spacing: "small", color: "invisible" }),
            isMobile ? this.renderMobileContent() : this.renderContent()));
    }
    get paragraphs() {
        const { translate } = this.translateStore;
        return [
            {
                heading: `1. ${translate('gdpr.privacy.notification.paragraph.what.is.in.this.privacy.notice')}`,
                content: react_1.default.createElement(ParagraphOneContent_1.ParagraphOneContent, { isMobile: this.props.isMobile })
            },
            {
                heading: `2. ${translate('gdpr.privacy.notification.paragraph.what.is.personal.data')}`,
                content: react_1.default.createElement(ParagraphTwoContent_1.ParagraphTwoContent, null)
            },
            {
                heading: `3. ${translate('gdpr.privacy.notification.paragraph.when.we.colect')}`,
                content: react_1.default.createElement(ParagraphThreeContent_1.ParagraphThreeContent, null)
            },
            {
                heading: `4. ${translate('gdpr.privacy.notification.paragraph.what.legal.ground')}`,
                content: react_1.default.createElement(ParagraphFourContent_1.ParagraphFourContent, null)
            },
            {
                heading: `4.1 ${translate('gdpr.privacy.notification.paragraph.what.is.marketing.profilin')}`,
                content: react_1.default.createElement(ParagraphFourContent_1.ParagraphFourPointOneContent, null),
                isSubParagraph: true
            },
            {
                heading: `5. ${translate('gdpr.privacy.notification.paragraph.automated.decisions')}`,
                content: react_1.default.createElement(ParagraphFiveContent_1.ParagraphFiveContent, null)
            },
            {
                heading: `6. ${translate('gdpr.privacy.notification.paragraph.how.long.we.store')}`,
                content: react_1.default.createElement(ParagraphSixContent_1.ParagraphSixContent, null)
            },
            {
                heading: `7. ${translate('gdpr.privacy.notification.paragraph.who.other.can.access')}`,
                content: react_1.default.createElement(ParagraphSevenContent_1.ParagraphSevenContent, null)
            },
            {
                heading: `8. ${translate('gdpr.privacy.notification.paragraph.how.do.we.protect')}`,
                content: react_1.default.createElement(ParagraphEightContent_1.ParagraphEightContent, null)
            },
            {
                heading: `9. ${translate('gdpr.privacy.notification.paragraph.choices.and.rights')}`,
                content: react_1.default.createElement(ParagraphNineContent_1.ParagraphNineContent, null)
            },
            {
                heading: `10. ${translate('gdpr.privacy.notification.paragraph.how.do.contact')}`,
                content: react_1.default.createElement(ParagraphTenContent_1.ParagraphTenContent, null)
            },
            {
                heading: `11. ${translate('gdpr.privacy.notification.paragraph.how.do.change')}`,
                content: react_1.default.createElement(ParagraphElevenContent_1.ParagraphElevenContent, null)
            },
            {
                heading: `12. ${translate('gdpr.privacy.notification.paragraph.contact.expert')}`,
                content: react_1.default.createElement(ParagraphTwelveContent_1.default, null)
            }
        ];
    }
};
PublicPrivacyNotice = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], PublicPrivacyNotice);
exports.default = PublicPrivacyNotice;
